export const buttonLabels = ['Especialidade', 'Cidade', 'Dia', 'Hospital']
